var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"header-title",attrs:{"dense":""}},[_vm._t("header-title")],2),_c('v-row',{staticClass:"header-description",attrs:{"dense":""}},[_vm._t("header-description")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }